import { motion } from "framer-motion";
import { TESTIMONIALS } from "../data/site";

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="bg-white border-y border-black/5 py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <p className="font-display text-xs uppercase tracking-[0.3em] font-semibold text-[#0047FF] mb-4">Proof, not promises</p>
      <h2 className="font-display font-black tracking-tighter text-4xl md:text-6xl leading-none mb-14 md:mb-20">
        People I've made <span className="text-[#0047FF]">money for.</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            data-testid={`testimonial-${i}`}
            className="flex flex-col justify-between rounded-lg border border-black/5 bg-[#FAFAFA] p-8 md:p-10"
          >
            <blockquote className="text-base md:text-lg leading-relaxed text-black/80 font-medium">"{t.quote}"</blockquote>
            <div className="mt-10">
              <p className="font-display font-black text-4xl md:text-5xl tracking-tighter text-[#0047FF]">{t.stat}</p>
              <p className="text-xs uppercase tracking-widest font-semibold text-black/40 mt-1 mb-6">{t.statLabel}</p>
              <figcaption className="border-t border-black/10 pt-4">
                <p className="font-display font-bold">{t.name}</p>
                <p className="text-sm text-black/50">{t.role}</p>
              </figcaption>
            </div>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
